/** Künye sayfası görseli (kaynak site). */
export const IMPRINT_IMAGE_SRC =
    'https://istanbulrotary.org/img/db/kunye.jpg';

/**
 * Çeviri anahtarları: `imprint.rows.<id>.label` / `.value` (`src/i18n/locales/*.json`).
 * @type {readonly string[]}
 */
export const IMPRINT_ROW_IDS = [
    'foundedDate',
    'foundingClub',
    'cabinetPermit',
    'charterDate',
    'charterNumber',
    'province',
    'registryNumber',
];
